import en from "./en.json";
import de from "./de.json";
import es from "./es.json";

const DICTS = { en, de, es };
export const UI_LANGS = [
  { value: "nl", label: "Nederlands" },
  { value: "en", label: "English" },
  { value: "de", label: "Deutsch" },
  { value: "es", label: "Español" },
];

let LANG = "nl";
export const setLang = (l) => {
  LANG = DICTS[l] ? l : "nl";
  document.documentElement.lang = LANG;
};
export const getLang = () => LANG;

// Vertaal een Nederlandse brontekst; {0}, {naam} worden vervangen door vars.
export function tx(s, vars) {
  if (typeof s !== "string") return s;
  let out = (LANG !== "nl" && DICTS[LANG][s]) || s;
  if (vars) out = out.replace(/\{(\w+)\}/g, (m, k) => (vars[k] ?? m));
  return out;
}

// Lazy vertaling voor module-constanten: alleen tekstvelden (label e.d.) en losse strings in arrays.
const TEXT_PROPS = new Set(["label", "title", "description", "note", "placeholder", "subtitle", "hint", "long", "help", "v", "desc", "empty", "unit"]);
const cache = new WeakMap();
export function lz(obj) {
  if (obj === null || typeof obj !== "object") return obj;
  if (cache.has(obj)) return cache.get(obj);
  const isArr = Array.isArray(obj);
  const flatMap = !isArr && Object.values(obj).every((x) => typeof x === "string");
  const p = new Proxy(obj, {
    get(target, prop, recv) {
      const v = Reflect.get(target, prop, recv);
      if (typeof v === "string") return (isArr ? /^\d+$/.test(String(prop)) : flatMap || TEXT_PROPS.has(prop)) ? tx(v) : v;
      if (v && typeof v === "object" && !(v instanceof Date) && !v.$$typeof) return lz(v);
      return v;
    },
  });
  cache.set(obj, p);
  return p;
}

const LOCALES = { nl: "nl-NL", en: "en-GB", de: "de-DE", es: "es-ES" };
export const uiLocale = () => LOCALES[LANG];
